import { Link } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { ErrorIllustration } from 'shared/assets/illustrations';
import { PageMeta } from 'shared/components/PageMeta';

export function ConflictPage() {
  const { t } = useI18n();
  return (
    <div className="state-page error-state">
      <PageMeta titleKey="errors.conflict" />
      <ErrorIllustration />
      <p className="code-display">409</p>
      <h1>{t('conflict.title')}</h1>
      <p>{t('conflict.body')}</p>
      <div className="action-row">
        <Link className="btn btn-primary" to={paths.home}>{t('notFound.home')}</Link>
        <Link className="btn btn-ghost" to={paths.welcome}>{t('actions.back')}</Link>
      </div>
    </div>
  );
}
